/* eslint-disable @typescript-eslint/no-namespace */

export namespace BarChartEvents {
  export const BAR_CHART_SELECTED_EVENT: string = "barChartSelected";
}